// =========================================================
// ブラウザ側の SSR hydrator。
// SSR 済み HTML (data-ssr-key を持つ要素) を検出し、隣の <script> から props を取り出して
// ReactDOM.hydrate する。frontend/packs/*.jsx が末尾で renderReact(name, Component) を呼ぶ形。
// =========================================================

// WARNING: DOM 走査に使う data-ssr-* 属性名は
// サーバー側 ssrServer.js / PlaceholderHtml と密結合。変更不可。

import React from 'react';
import ReactDOM from 'react-dom';

export function renderReact(name, Component) {
  if (typeof window === 'undefined') {
    return Component;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => hydrateAll(name, Component));
  } else {
    hydrateAll(name, Component);
  }

  return Component;
}

function hydrateAll(name, Component) {
  // NOTE: サーバー側が data-ssr-key に入れる際の \W 除去と揃える。
  const key = String(name).replace(/\W/g, '');
  const containers = document.querySelectorAll(`div[data-ssr-key="${cssEscape(key)}"]`);
  containers.forEach((container) => hydrateOne(container, key, Component));
}

function hydrateOne(container, key, Component) {
  const id = container.getAttribute('data-ssr-id');
  if (!id) return;

  const script = document.querySelector(
    `script[type="application/json"][data-ssr-key="${cssEscape(key)}"][data-ssr-id="${cssEscape(id)}"]`,
  );
  if (!script) return;

  const props = parseProps(script.textContent);
  if (props === null) return;

  try {
    ReactDOM.hydrate(React.createElement(Component, props), container);
  } catch (err) {
    console.error(`SSR hydrate failed for ${key}:`, err);
  }
}

function parseProps(raw) {
  if (!raw) return null;
  try {
    return JSON.parse(raw.trim());
  } catch (e) {
    console.error('SSR hydrate: invalid JSON', e);
    return null;
  }
}

// NOTE: 古いブラウザ向けに window.CSS.escape のフォールバックを用意。
function cssEscape(value) {
  if (typeof window !== 'undefined' && window.CSS && typeof window.CSS.escape === 'function') {
    return window.CSS.escape(value);
  }
  return String(value).replace(/(["\\])/g, '\\$1');
}

export default { renderReact };
